const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

document.querySelectorAll("[data-tabs]").forEach((group) => {
  const buttons = [...group.querySelectorAll("[data-tab-button]")]
  const panels = group.querySelectorAll("[data-tab-panel]")
  const autoplayMs = Number.parseInt(group.dataset.autoplay, 10)
  let index = 0
  let timer = null

  const activate = (name) => {
    index = buttons.findIndex((btn) => btn.dataset.tabButton === name)
    buttons.forEach((btn) => {
      const isActive = btn.dataset.tabButton === name
      btn.classList.toggle("is-active", isActive)
      btn.setAttribute("aria-selected", String(isActive))
      const bar = btn.querySelector("[data-tab-progress]")
      if (bar) bar.style.transform = "scaleX(0)"
    })
    panels.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.tabPanel !== name)
    })
  }

  const stop = () => {
    if (timer) clearInterval(timer)
    timer = null
  }

  const advance = () => {
    index = (index + 1) % buttons.length
    activate(buttons[index].dataset.tabButton)
    if (autoplayMs) startProgress()
  }

  const startProgress = () => {
    const bar = buttons[index].querySelector("[data-tab-progress]")
    if (!bar) return
    bar.style.transition = "none"
    bar.style.transform = "scaleX(0)"
    // Force reflow so the transition below actually animates from 0.
    void bar.offsetWidth
    bar.style.transition = `transform ${autoplayMs}ms linear`
    bar.style.transform = "scaleX(1)"
  }

  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      stop()
      activate(btn.dataset.tabButton)
      if (autoplayMs) {
        startProgress()
        timer = setInterval(advance, autoplayMs)
      }
    })
  })

  if (buttons[0]) activate(buttons[0].dataset.tabButton)

  if (autoplayMs && !reduceMotion) {
    startProgress()
    timer = setInterval(advance, autoplayMs)
    group.addEventListener("mouseenter", stop)
    group.addEventListener("mouseleave", () => {
      if (!timer) {
        startProgress()
        timer = setInterval(advance, autoplayMs)
      }
    })
  }
})
